// Phase 6.C — 작업일정 data shapes.
//
// 본 trace (2026-05-03 Track A): mock 데이터 전부 제거.
// 작업일정 = 회사별 격리 데이터 (사장/직원이 직접 등록). 신규 회사 = empty state.
// 향후 Phase 7 메일·SMS 인프라 + DB schedule 모델 도입 시 회사별 격리 spec
// (사용자 명시 5건) 으로 backend 활성. 본 파일은 shape (type) 만 유지.
//
// 이전 mock 본문 (직원 6명 / SCH_LOW_STOCK 4건 / SCHEDULE_SECTIONS 5섹션) 은
// git history (commit `0ed7015` 직전) 에 보존 — 향후 시안 참고용으로 복원 가능.
//
// docs/ALGORITHM_FLOW.md §X (작업일정 회사별 격리 spec) 참조.

export type ScheduleChannel = 'sms' | 'kakao' | 'telegram';
export type ScheduleGroup = 'morning' | 'afternoon' | 'prep' | 'all';

export interface ScheduleStaff {
  id: string;
  name: string;
  role: string;
  channel: ScheduleChannel;
  phone: string;
  group: ScheduleGroup;
}

export interface ScheduleTask {
  t: string;
  time: string;
  who: string;
  /** closing 섹션 응답 여부 (response 모드일 때만) */
  answered?: boolean;
  /** answered=true 인 경우 응답한 직원 + 시각 */
  by?: string | null;
}

export interface ScheduleSection {
  id: 'common' | 'morning' | 'afternoon' | 'prep' | 'closing';
  title: string;
  icon: string;
  /** CSS color (var(...) or hex). 시안 정확 매핑. */
  accent: string;
  sub: string;
  /** 전처리 — 부족재고 자동연결 표시 */
  autoStock?: boolean;
  /** closing — 응답형 (체크리스트 발송 후 응답 수신) */
  isResponse?: boolean;
  tasks: ScheduleTask[];
}

// 회사별 격리 데이터 — 사장/직원이 직접 등록. 본 trace = mock 제거 → 빈 배열.
// 향후 Phase 7 backend 활성 시 = service layer companyId filter + RLS 정책으로
// 회사별 격리 (= P0 receipt_inbox 패턴 참고).
export const SCH_STAFF: ScheduleStaff[] = [];

export const SCH_LOW_STOCK: Array<{ name: string; qty: string; need: string; store: string }> = [];

export const SCHEDULE_SECTIONS: ScheduleSection[] = [];

export function findSection(id: string | undefined): ScheduleSection | undefined {
  return SCHEDULE_SECTIONS.find((s) => s.id === id);
}
